module.exports = __webpack_public_path__ + "img/module-element-angle.993943ee.svg";